<div class="container-fluid gx-0 d-flex flex-column min-vh-100 app-bg-color">
  <app-header-new></app-header-new>
  <div class="row gx-0 flex-grow-1">
    <div class="col content-wrapper mx-auto my-auto p-3 w-312">
         <img
        src="../../../../assets/images/rejection-error-round.svg"
        class="d-flex mx-auto status-image"
        alt="icon"
      />
        <div class="mt-4">
        <ng-container>
          <div class="text-center">
            <h3 class="mb-0 fw-medium">
          @if(productName === 'change-address'){
            Die Adresse konnte nicht geändert werden.
          } 
          @else if(productName === 'change-email'){
            Die E-Mail-Adresse konnte nicht geändert werden.
          } 
          @else if(productName === 'change-contact'){
            Die Mobilnummer konnte nicht geändert werden.
            }
           @else if(productName === 'change-name'){
            Der Name konnte nicht geändert werden.
          }
            </h3>
          </div>
           <div class="justify-content-between text-center">
             <p class="description mt-4">
             Bitte versuchen Sie es erneut.
            </p>
           </div>
        </ng-container>
    </div>
     <div class="d-grid mt-40">
        <button
          class="btn btn-primary btn-nav d-md-block mx-md-auto btn-prima"
          (click)="onCloseClicked()"
          role="button"
          tabindex="0"
        >
          Schließen
        </button>
      </div>
    </div>
  </div>
    <app-footer></app-footer>
</div>    